import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import { useNotification } from '@revenuewell/front-end-bundle';
import { FC, useEffect, useState } from 'react';
import { useInsuranceApi } from '../../../../../hooks/use-insurance-api';
import { ProviderSelectionDialog } from '../../../shared/components/provider-selection-dialog/provider-selection-dialog';
import { usePatientIvStatusDialog } from '../../hooks/use-patient-iv-status-dialog/hook';

export interface IButtonProps {
  label?: string;
  onSuccess: () => Promise<void>;
  disabled?: boolean;
}

export const RunVerificationButton: FC<IButtonProps> = (props) => {
  const { label, onSuccess, disabled } = props;
  const { showError, showSuccess } = useNotification();
  const { status, runVerification } = useInsuranceApi();
  const {
    locationId,
    providerId,
    patientFlow,
    sendIvStatusUpdatedEvent,
    setIsLoading,
    verificationPriority,
    providers
  } = usePatientIvStatusDialog();
  const [providerDialogOpen, setProviderDialogOpen] = useState(false);

  useEffect(() => {
    if (status.runVerification.error) showError('Unable to perform the operation.');
  }, [status.runVerification.error]);

  const updateInsuranceStatus = async () => {
    providerId ? await runVerificationRequest(providerId) : setProviderDialogOpen(true);
  };

  const runVerificationRequest = async (providerId: number) => {
    setIsLoading(true);

    const success = await runVerification(locationId, patientFlow.patientId, providerId, verificationPriority);

    if (success) {
      showSuccess('Verification is started.');
      sendIvStatusUpdatedEvent('InsuranceInProcess');
      await onSuccess();
    }

    setIsLoading(false);
  };

  const handleProviderDialogSubmit = async (selectedProviderId: number) => {
    await runVerificationRequest(selectedProviderId);
    setProviderDialogOpen(false);
  };

  const handleProviderDialogClose = () => {
    setProviderDialogOpen(false);
  };

  return (
    <Box>
      <LoadingButton
        disableElevation
        variant="outlined"
        color="primary"
        onClick={updateInsuranceStatus}
        loading={status.runVerification.isRunning}
        disabled={disabled}
      >
        {label ?? 'Run Verification'}
      </LoadingButton>
      <ProviderSelectionDialog
        open={providerDialogOpen}
        title="Run Verification - Choose Provider"
        providers={providers}
        onClose={handleProviderDialogClose}
        onSubmit={handleProviderDialogSubmit}
      />
    </Box>
  );
};
